import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { submitForm } from "./contactThunk";

export type ContactForm = {
    productName: string;
    description: string;
    platform: string;
    type: string;
    email: string;
    category: string;
};

interface ContactState {
    processing: boolean;
    showForm: boolean;
    formData: ContactForm;
}

const initialState: ContactState = {
    processing: false,
    showForm: false,
    formData: {
        productName: "",
        description: "",
        platform: "",
        type: "",
        email: "",
        category: "",
    },
};

const slice = createSlice({
    name: "contact",
    initialState,
    reducers: {
        setFormState: (state: ContactState, action: PayloadAction<any>) => {
            state.showForm = action.payload;
        },
        setFormData: (state: ContactState, action: PayloadAction<any>) => {
            state.formData = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(submitForm.pending, state => {
                state.processing = true;
            })
            .addCase(submitForm.fulfilled, state => {
                state.processing = false;
                state.showForm = false;
                state.formData = initialState.formData;
            })
            .addCase(submitForm.rejected, state => {
                state.processing = false;
            });
    },
});

export const { setFormState, setFormData } = slice.actions;

export default slice.reducer;
